export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetItems = data.items.length;

      if (widgetItems >= 1) {
        $(`#${widgetName} .card-widget-item`).each(function () {
          $(this).find('.moreButton').addClass('button');
          $(this).find('.button').removeClass('moreButton');
          $(this).find('.button').removeAttr('target');
        });
      } else {
        $('.tier-2-container').remove();
      }
    },
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'Become a Member',
    },
    buyNowButton: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    link: [],
    scriptPath: widgetOpts.scriptPath,
  });
}
